export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ProfilePublicationAgreement.vue?vue&type=template&id=6a6e34d6&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/ProfilePublicationAgreement.vue?vue&type=template&id=6a6e34d6&
// module id = 1248
// module chunks = 0